<template>
    <div class="shop-records-container">
        <a-card title="店铺记录查询" :bordered="false">
            <div class="search-container">
                <a-form layout="inline" :model="searchForm">
                    <a-form-item label="店铺名称">
                        <a-input v-model:value="searchForm.shop_name" placeholder="请输入店铺名称" />
                    </a-form-item>
                    <a-form-item label="登录账号">
                        <a-input v-model:value="searchForm.login_account" placeholder="请输入手机号" />
                    </a-form-item>
                    <a-form-item label="记录类型">
                        <a-select v-model:value="searchForm.record_type" style="width: 120px" placeholder="请选择">
                            <a-select-option value="">全部</a-select-option>
                            <a-select-option value="settlement">结算</a-select-option>
                            <a-select-option value="daily_report">日报</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="日期范围">
                        <a-range-picker v-model:value="searchForm.dateRange" />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="handleSearch">查询</a-button>
                        <a-button style="margin-left: 8px" @click="resetSearch">重置</a-button>
                        <a-button type="primary" style="margin-left: 8px" @click="handleExport"
                            :loading="exportLoading">
                            导出Excel
                        </a-button>
                    </a-form-item>
                </a-form>
            </div>

            <a-table :columns="columns" :data-source="data" :pagination="pagination" :loading="loading"
                @change="handleTableChange" bordered>
                <template #bodyCell="{ column, record }">
                    <template v-if="column.dataIndex === 'settlement_amount'">
                        <span :class="{ 'negative-amount': record.settlement_amount < 0 }">
                            {{ formatAmount(record.settlement_amount) }}
                        </span>
                    </template>
                    <template v-else-if="column.dataIndex === 'order_gmv'">
                        {{ formatAmount(record.order_gmv) }}
                    </template>
                    <template v-else-if="column.dataIndex === 'order_commission'">
                        {{ formatAmount(record.order_commission) }}
                    </template>
                    <template v-if="column.dataIndex === 'created_at'">
                        {{ formatDateTime(record.created_at) }}
                    </template>
                    <template v-if="column.dataIndex === 'date_display'">
                        {{ formatDateTime2(record.date_display) }}
                    </template>
                </template>
            </a-table>
        </a-card>
    </div>
</template>

<script>
// 导入神煞组件

import { message } from 'ant-design-vue'; // 添加这行导入
import axios from 'axios';
import moment from 'moment'; // 导入 moment
import { onMounted, reactive, ref } from 'vue';

export default {
    setup() {
        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                width: 80,
                sorter: true,
            },
            {
                title: '店铺名称',
                dataIndex: 'shop_name',
                width: 120,
            },
            {
                title: '登录账号',
                dataIndex: 'login_account',
                width: 120,
            },
            {
                title: '记录类型',
                dataIndex: 'record_type',
                width: 100,
                filters: [
                    { text: '结算', value: 'settlement' },
                    { text: '日报', value: 'daily_report' },
                ],
            },
            {
                title: '日期',
                dataIndex: 'date_display',
                width: 150,
                sorter: true,
            },
            {
                title: '订单数',
                dataIndex: 'order_cnt',
                width: 100,
            },
            {
                title: 'GMV',
                dataIndex: 'order_gmv',
                width: 120,
            },
            {
                title: '佣金',
                dataIndex: 'order_commission',
                width: 120,
            },
            {
                title: '结算金额',
                dataIndex: 'settlement_amount',
                width: 120,
            },
            {
                title: '创建时间',
                dataIndex: 'created_at',
                width: 180,
                sorter: true,
            },
        ];

        const formatDateTime = (dateTimeStr) => {
            return moment(dateTimeStr).format('YYYY-MM-DD HH:mm:ss');
        };
        const formatDateTime2 = (dateTimeStr) => {
            return moment(dateTimeStr).format('YYYY-MM-DD');
        };

        const data = ref([]);
        const loading = ref(false);
        const pagination = reactive({
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
        });

        const searchForm = reactive({
            shop_name: '',
            login_account: '',
            record_type: '',
            dateRange: [],
        });

        const fetchData = async (params = {}) => {
            loading.value = true;
            try {
                const queryParams = {
                    page: pagination.current,
                    page_size: pagination.pageSize,
                    ...params,
                };

                // 处理日期范围
                if (searchForm.dateRange && searchForm.dateRange.length === 2) {
                    queryParams.start_date = searchForm.dateRange[0].format('YYYY-MM-DD');
                    queryParams.end_date = searchForm.dateRange[1].format('YYYY-MM-DD');
                }

                const response = await axios.get('/api/shop_records', { params: queryParams });
                data.value = response.data.data.map(item => ({
                    ...item,
                    date_display: item.record_type === 'settlement'
                        ? `${item.start_date}${item.start_date !== item.end_date ? ` ~ ${item.end_date}` : ''}`
                        : item.report_date,
                }));
                pagination.total = response.data.total;
            } catch (error) {
                console.error('获取数据失败:', error);
            } finally {
                loading.value = false;
            }
        };

        const handleSearch = () => {
            pagination.current = 1;
            const params = {
                shop_name: searchForm.shop_name,
                login_account: searchForm.login_account,
                record_type: searchForm.record_type,
            };
            fetchData(params);
        };

        const resetSearch = () => {
            searchForm.shop_name = '';
            searchForm.login_account = '';
            searchForm.record_type = '';
            searchForm.dateRange = [];
            handleSearch();
        };

        const handleTableChange = (pag, filters, sorter) => {
            pagination.current = pag.current;
            pagination.pageSize = pag.pageSize;

            const params = {
                ...filters,
            };

            if (sorter.field) {
                params.sort_field = sorter.field;
                params.sort_order = sorter.order === 'ascend' ? 'asc' : 'desc';
            }

            fetchData(params);
        };

        const formatAmount = (value) => {
            if (value === null || value === undefined) return '-';
            return `¥${Number(value).toFixed(2)}`;
        };

        onMounted(() => {
            fetchData();
        });


        // 原有代码保持不变...
        const exportLoading = ref(false);

        const handleExport = async () => {
            exportLoading.value = true;
            try {
                // 构建导出参数（可以根据需要添加当前查询条件）
                const params = {
                    shop_name: searchForm.shop_name,
                    login_account: searchForm.login_account,
                    record_type: searchForm.record_type,
                };

                // 处理日期范围
                if (searchForm.dateRange && searchForm.dateRange.length === 2) {
                    params.start_date = searchForm.dateRange[0].format('YYYY-MM-DD');
                    params.end_date = searchForm.dateRange[1].format('YYYY-MM-DD');
                }

                // 使用axios下载文件
                const response = await axios({
                    url: 'http://127.0.0.1:8082/api/download',
                    method: 'GET',
                    params: params,
                    responseType: 'blob' // 重要：指定响应类型为blob
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', '店铺记录.xlsx'); // 设置下载文件名
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                message.success('导出成功');
            } catch (error) {
                console.error('导出失败:', error);
                message.error('导出失败: ' + (error.response?.data?.message || error.message));
            } finally {
                exportLoading.value = false;
            }
        };

        return {
            columns,
            data,
            pagination,
            loading,
            searchForm,
            handleSearch,
            resetSearch,
            handleTableChange,
            formatAmount,
            exportLoading,
            handleExport,
            formatDateTime, formatDateTime2
        };
    },
};
</script>

<style scoped>
.shop-records-container {
    padding: 24px;
    background: #fff;
}

.search-container {
    margin-bottom: 24px;
}

.negative-amount {
    color: #f5222d;
}
</style>